module.exports = __webpack_public_path__ + "img/ys.48092622.png";